import { render, staticRenderFns } from "./ClassroomSearchSlidebar.vue?vue&type=template&id=e861aac0"
import script from "./ClassroomSearchSlidebar.vue?vue&type=script&lang=js"
export * from "./ClassroomSearchSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports